module.exports = "/_next/static/images/ObserveYourData-e812fc837d7260bd9ce965f538447397.webp";